import defaultStyles from "./privacy-policy-default.module.scss";
import mobileStyles from "./privacy-policy-mobile.module.scss";
import DomPurify from "isomorphic-dompurify";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import classNames from "classnames";

export function usePrivacyPolicyCommon(staticPageContent: string) {
  const { t } = useTranslation();
  const { layoutType } = useLayoutType();
  const isMobile = layoutType === LayoutTypes.TYPE_MOBILE;

  const additionalStyles = isMobile ? mobileStyles : defaultStyles;

  const content = useMemo(() => {
    return DomPurify.sanitize(staticPageContent);
  }, [staticPageContent]);

  const renderContent = () => {
    const contentClassnames = classNames({
      [defaultStyles[LayoutStyleTypes.TYPE_SM]]: isMobile,
    });

    return (
      <div className={defaultStyles.wrapper}>
        <div className={additionalStyles.topcard}>
          <div className={additionalStyles.rowTitle}>
            <h1 className={additionalStyles.title}>{t("83p9sscfj2b6t121.privacy-policy", "Privacy Policy")}</h1>
          </div>
        </div>
        <div className={contentClassnames} dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    );
  };

  return {
    renderContent
  };
}
